import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.23_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.55.1_react-dom@18_xetxberr2yhkllknuyzdyjbw3u/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["TemplateDetailPage"] */ "/vercel/path0/packages/service/src/components/TemplateDetailPage/TemplateDetailPage.tsx");
